import { useEffect, useState } from "react";

function fmtClock(d) {
  return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", second: "2-digit" });
}
function fmtDate(d) {
  return d.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" });
}

export default function LiveClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="text-right" data-testid="live-clock">
      <div className="text-2xl font-display font-bold tabular-nums text-slate-900">{fmtClock(now)}</div>
      <div className="text-xs text-slate-500">{fmtDate(now)}</div>
    </div>
  );
}
